import service from "@/utils/request";

export function getPartnerTaskList(params) {
    return service({
        url: "/partnerTask/page",
        method: "get",
        params,
    });
}

export function getPartnerTaskDetail(params) {
    return service({
        url: "/partnerTask/detail",
        method: "get",
        params,
    });
}
export function createPartnerTask(data) {
    return service({
        url: "/partnerTask/create",
        method: "post",
        data,
    });
}
export function updatePartnerTask(data) {
    return service({
        url: "/partnerTask/update",
        method: "post",
        data,
    });
}
export function publishPartnerTask(data) {
    return service({
        url: "/partnerTask/publish?id=" + data.id,
        method: "post",
    });
}
export function deletePartnerTask(data) {
    return service({
        url: "/partnerTask/delete?id=" + data.id,
        method: "post",
    });
}

